import React, { createContext, useState, useEffect, useContext } from 'react';
import { getFaculties, createFaculty, updateFaculty, deleteFaculty } from '@services/facultyService';

const FacultyContext = createContext();

export const FacultyProvider = ({ children }) => {
  const [faculties, setFaculties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFaculties = async () => {
      try {
        const data = await getFaculties();
        setFaculties(data);
      } catch (error) {
        console.error('Error fetching faculties:', error);
        setError('Failed to fetch faculties data.');
      } finally {
        setLoading(false);
      }
    };

    fetchFaculties();
  }, []);

  const addFaculty = async (facultyData) => {
    try {
      const newFaculty = await createFaculty(facultyData);
      setFaculties([...faculties, newFaculty]);
    } catch (error) {
      console.error('Error adding faculty:', error);
      throw error;
    }
  };

  const editFaculty = async (facultyId, facultyData) => {
    try {
      const updatedFaculty = await updateFaculty(facultyId, facultyData);
      setFaculties(faculties.map(faculty => 
        faculty.id === facultyId ? updatedFaculty : faculty
      ));
    } catch (error) {
      console.error('Error updating faculty:', error);
      throw error;
    }
  };

  const removeFaculty = async (facultyId) => {
    try {
      await deleteFaculty(facultyId);
      setFaculties(faculties.filter(faculty => faculty.id !== facultyId));
    } catch (error) {
      console.error('Error deleting faculty:', error);
      throw error;
    }
  };

  return (
    <FacultyContext.Provider value={{ faculties, loading, error, addFaculty, editFaculty, removeFaculty }}>
      {error ? (
        <div className="flex items-center justify-center h-screen">
          <p className="text-red-500">{error}</p>
        </div>
      ) : (
        children
      )}
    </FacultyContext.Provider>
  );
};

export const useFaculties = () => useContext(FacultyContext);
